<template>
  <v-form class='createJointTypeForm' v-model='valid' ref='createJointTypeForm'>
    <v-container class='mb-10'>
      <v-row>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='jointType.name'
            :error-messages='error.name'
            label='Name'
            placeholder='Name'
            autofocus
            ref="firstInput"
          ></v-text-field>
        </v-col>
        <!-- <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='jointType.company_id'
            :error-messages='error.company_id'
            label='Company'
            placeholder='Select Company'
          ></v-text-field>
        </v-col> -->
        <v-col cols='12' md='3' sm='6' xs='12' class='radio-with-lable'>
          <label class="c-radio-label">Status</label>
          <v-radio-group v-model="jointType.status" row>
            <v-radio label="Active" :value="0" class="mt-0"></v-radio>
            <v-radio label="Inactive" :value="1" class="mt-0"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
    </v-container>
    <v-footer fixed>
      <v-col class="text-right">
        <v-btn color="primary" class="mr-2" @click="submit" small>{{ edit_id ? 'Update' : 'Add' }}</v-btn>
        <v-btn color="default" @click="reset" small>Reset</v-btn>
      </v-col>
    </v-footer>
  </v-form>
</template>

<script>
export default {
  watch: {
    $route: function () {
      this.edit_id = this.$route.params.id
      this.reset()
    }
  },
  props: ['isFromPopup'],
  mounted () {
    const id = this.$route.params.id
    if (id && !this.isFromPopup) {
      this.edit_id = id
      this.$axios.post('getJointTypeById/' + id).then((res) => {
        this.jointType = res.data.data
      }).catch(() => {
        this.loading = false
        console.log('some error occurred')
      })
    } else {
      this.edit_id = undefined
    }
  },
  data () {
    return {
      valid: false,
      edit_id: undefined,
      jointType: { status: 0 },
      error: {},
    }
  },
  methods: {
    submit () {
      if (Object.keys(this.error).length > 0) {
        this.error = {}
        this.valid = true
      }
      if (this.valid) {
        const route = this.edit_id ? 'saveJointType/' + this.edit_id : 'saveJointType'
        this.$axios.post(route, this.jointType).then((res) => {
          this.$eventBus.$emit('$globalSnackbar', 'success', res.data.success_description)
          if (this.edit_id) {
            this.$router.push('/jointType')
          } else {
            this.reset()
          }
        }).catch((err) => {
          if (err.response.status === 422) {
            this.error = err.response.data.error_data
          } else {
            this.$eventBus.$emit('$globalSnackbar', 'red', err.response.data.error_description)
          }
        })
      } else {
        this.$refs.createJointTypeForm.validate()
      }
    },
    reset () {
      this.$refs.createJointTypeForm.reset()
      setTimeout(() => {
        this.jointType = { status: 0 }
        this.error = {}
        this.$refs.firstInput.focus()
      }, 300)
    },
  },
}
</script>

<style>
.createJointTypeForm .radio-with-lable .v-input--selection-controls {
  margin-top: 0px;
}
.createJointTypeForm .c-radio-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
}
</style>
